import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Form,
  Segment
} from 'semantic-ui-react';

import { getValue } from '_utils';

import BaseInputField from '_forms/baseInput';

const CreateInstitutionInviteForm = ({
  onCancel,
  onSubmit
}) => {

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: ""
  })

  const onChange = (e, data) => {
    const update = { [data.name]: getValue(data) };
    setFormData(Object.assign({}, formData, update));
  };

  const onSubmitForm = () => onSubmit(formData);

  return (
    <Segment>
      <Form onSubmit={ onSubmitForm }>
        <Form.Group widths='equal'>
          <BaseInputField
            width={ 16 }
            name='first_name'
            type='text'
            value={ formData.first_name }
            onChange={ onChange }
            labelTxt='First Name'
            popupTxt='The first name of the Institutional Admin you are about to invite.'
          />
          <BaseInputField
            width={ 16 }
            name='last_name'
            type='text'
            value={ formData.last_name }
            onChange={ onChange }
            labelTxt='Last Name'
            popupTxt='The last name of the Institutional Admin you are about to invite.'
          />
        </Form.Group>
        <Form.Group>
          <BaseInputField
            width={ 16 }
            name='email'
            type='text'
            value={ formData.email }
            onChange={ onChange }
            labelTxt='Email'
            popupTxt='The email address of the Institutional Admin you are about to invite.'
          />
        </Form.Group>
        <Button.Group>
          <Button onClick={ onCancel }>Cancel</Button>
          <Button.Or />
          <Button positive type="submit">Create Invite</Button>
        </Button.Group>
      </Form>
    </Segment>
  );
};

CreateInstitutionInviteForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CreateInstitutionInviteForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/institutionInviteForm.js